/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2025.

!Changelog

2025
	07-02-2025
	- [CHANGE] poll_connection is gone, not needed anymore.
2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_interactions_firstload = {};

(function () {

	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	/**
	None yet
	**/

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function () {

		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		// if(pollConnection === 1) { poll_connection.onready(); } (OBSOLETE 07-02-2025)

		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();
		specific_spotlight.onready();
		specific_team.onready();
		specific_work.onready();

		/*
		Back to top
		*/
		$(document).on('click', '.js-back-to-top', function () {

			var _duration = $(window).height() / 0.5;

			$('html, body').animate({
				scrollTop: 0
			}, {
				duration: _duration,
				easing: 'easeInOutCubic'
			});

		});

		// IntersectionObserver aanmaken
		window._videoObserver = new IntersectionObserver(function (entries) {
			$.each(entries, function (i, entry) {
				var video = entry.target;

				if (entry.isIntersecting) {
					if (!video.dataset.loaded) {
						const source = document.createElement('source');
						source.src = video.dataset.src;
						source.type = 'video/mp4';
						video.appendChild(source);

						video.load();
						video.dataset.loaded = "true";

						video.addEventListener('canplaythrough', function handlePlayOnce() {
							video.play();
							video.classList.add('is-ready');
							video.removeEventListener('canplaythrough', handlePlayOnce);
						});
					} else {
						video.play();
					}
				} else {
					video.pause();
				}
			});
		}, {
			threshold: 0.8
		});

		// MutationObserver om nieuwe nodes automatisch te observeren
		window._videoMutationObserver = new MutationObserver(function (mutations) {
			$.each(mutations, function (i, mutation) {
				$.each(mutation.addedNodes, function (j, node) {
					if (node.nodeType !== 1) return;

					if (node.tagName && node.tagName.toLowerCase() === 'video') {
						var $node = $(node);
						if (!$node.attr('data-observed')) {
							_videoObserver.observe(node);
							$node.attr('data-observed', 'true');
						}
					}

					$(node).find('video').each(function () {
						var $vid = $(this);
						if (!$vid.attr('data-observed')) {
							_videoObserver.observe(this);
							$vid.attr('data-observed', 'true');
						}
					});
				});
			});
		});

		// Start observer
		_videoMutationObserver.observe(document.body, {
			childList: true,
			subtree: true
		});

		/*
		Referer
		*/
		// _ref = 'aachercules.nl';
		
		if (
			_ref != ''
		) {

			switch (_ref) {
				case 'aachercules.nl':
				case 'petjeaf.nl':
				case 'tyresale.nl':	
				case 'mecompany.nu':
					
					popup.open(1,1,'start/' + _ref);

				break;
			}
		}

		// var rotation = 0;
		// var rotateInterval;
		// var isHovering = false;

		// $(document).on('mouseenter', '.js-back-to-top .icon', function () {
		// 	const $icon = $(this);
		// 	isHovering = true;

		// 	function rotateIcon() {
		// 		if (!isHovering) return;
		// 		rotation += 2; // snelheid van draaien
		// 		$icon.css('transform', 'rotate(' + rotation + 'deg)');
		// 		requestAnimationFrame(rotateIcon);
		// 	}

		// 	requestAnimationFrame(rotateIcon);
		// });

		// $(document).on('mouseleave', '.js-back-to-top .icon', function () {
		// 	isHovering = false;
		// });

		/*
		Visitor recording
		*/
		//specific_visitor_recording.onready();

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_firstload); 